// notificationsData.js
// Ces données peuvent être placées dans un fichier distinct ou directement dans le composant parent

export const notificationsData = [
  {
    id: 1,
    title: "Demande d'absence à approuver",
    description: "MBELA Elage - Congé maladie",
    date: "26/04/2025",
    priority: "urgent", // urgent, important, faible
    target: {
      tab: 'employees',
      subTab: 'variable',
      variableTab: 'absences'
    },
    read: false,
    archived: false
  },
  {
    id: 2,
    title: "Contrat à renouveler",
    description: "ATIPO Liliane - Échéance dans 7 jours",
    date: "25/04/2025",
    priority: "important",
    target: {
      tab: 'documents',
    },
    read: false,
    archived: false
  },
  {
    id: 3,
    title: "Évaluation à planifier",
    description: "Nguesso Daniel - Période d'essai",
    date: "24/04/2025",
    priority: "important",
    target: {
      tab: 'evaluation',
    },
    read: false,
    archived: false
  },
  {
    id: 4,
    title: "Demande d'avance sur salaire",
    description: "KOTI Serge - 100 000 FCFA",
    date: "23/04/2025",
    priority: "important",
    target: {
      tab: 'employees',
      subTab: 'variable',
      variableTab: 'salary-advance'
    },
    read: true,
    archived: false
  },
  {
    id: 5,
    title: "Formation à planifier",
    description: "Formation Excel - 5 employés",
    date: "20/04/2025",
    priority: "faible",
    target: {
      tab: 'employees',
      subTab: 'tracking'
    },
    read: false,
    archived: false
  },
  // Exemples de notifications archivées
  {
    id: 6,
    title: "Entretien annuel terminé",
    description: "OUSMANE Marie - Objectifs validés",
    date: "19/04/2025",
    priority: "important",
    target: {
      tab: 'evaluation',
    },
    read: true,
    archived: true
  },
  {
    id: 7,
    title: "Mise à jour du contrat",
    description: "DIOP Paul - Avenant signé",
    date: "18/04/2025",
    priority: "faible",
    target: {
      tab: 'documents',
    },
    read: true,
    archived: true
  }
];